import React, {useRef} from 'react';
import {Link} from "react-router-dom";
import useOnClickOutSide from "../../components/Hooks/useClickOutside";
import "./menuBar.css";

function Hamburger(props) {
    const {handleHamburgerClick} = props;
    const ref = useRef();
    const currentPath = props.location.pathname;

    useOnClickOutSide(ref, () => {
        handleHamburgerClick();
    });

    const menuItemClass = (path) =>
        currentPath === path
            ? 'menu-item-active remove-underline'
            : 'remove-underline theme-text-black theme-font-normal theme-font-content';

    const navItems = [
        {label: 'Home',                        path: '/'},
        {label: 'AI Capabilities',                     path: '/services/ai-capabilities'},
        {label: 'Technology Partnership',       path: '/services/technology-partnership'},
        {label: 'Custom Software Development',  path: '/services/custom-software-development'},
        {label: 'Contact Us',                   path: '/contact-us'},
    ];

    return (
        <div className='theme-bg-white position-fixed h-100 top-0'
             style={{width: 300, right: 0}}
             ref={ref}>
            <div className='bg-white' style={{height: '100vh'}}>

                {/* Close button */}
                <div className='py-3 pe-3 mx-3 text-end'>
                    <i className="fa-solid fa-xmark"
                       style={{cursor: 'pointer', fontSize: 18}}
                       onClick={handleHamburgerClick}/>
                </div>

                {/* Nav items */}
                {navItems.map(({label, path}) => (
                    <div key={path}
                         className='py-3 mx-3 pe-3'
                         style={{borderBottom: '1px solid #c5c5c5'}}
                         onClick={handleHamburgerClick}>
                        <Link className={menuItemClass(path)} to={path}>
                            {label}
                        </Link>
                    </div>
                ))}

            </div>
        </div>
    );
}

export default Hamburger;
